import React, { Component } from "react"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css" // This only needs to be imported once in your app

export default class PortfolioLightbox extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { images, isOpen, photoIndex } = this.props
    return (
      <div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={this.props.onLightboxCloseRequest}
            onMovePrevRequest={() =>
              this.props.onIndexChanged(
                (photoIndex + images.length - 1) % images.length
              )
            }
            onMoveNextRequest={() =>
              this.props.onIndexChanged((photoIndex + 1) % images.length)
            }
          />
        )}
      </div>
    )
  }
}
